import React from 'react';
import { ReactComponent as Face } from './img/facebook.svg';
import { ReactComponent as Mes } from './img/messenger.svg';
import { ReactComponent as Wats } from './img/whatsapp.svg';
import './styling/footer.css';

export const Footer = () => {
    return (<>
        <footer>
            <div className="foot">
                <span>+20 109 741 207</span>
                <a href="https://www.facebook.com/yahia.mahmood.33" target="blank">
                    <Face/>
                </a>
                <a href="https://www.messenger.com/t/100029711623658" target="blank">
                    <Mes/>
                </a>
                <a href="https://web.whatsapp.com/" target="blank">
                    <Wats/>
                </a>
                <a href="https://github.com/yahia997" target="blank">
                    <img src="https://img.icons8.com/fluent/48/ffffff/github.png" alt="gitHub"/>
                </a>
            </div>
        </footer>
        <p className="copy">&copy;جميع الحقوق محفوظة</p>
        </>
    )
}